import React from "react";
import {NavLink} from "@reside/ui";
import {NavigationProps} from "./types";
import {RoleNameEnum} from "../../../utils/types/common";

/** Tabs always visible in navigation bar next to one another. */
export const Tabs = ({
  role,
  displayReportingTab,
  organizationId,
  organizationName,
}: NavigationProps) => {
  // ORGANIZATION_IT_ADMIN sees only SSO Configuration tab
  if (role === RoleNameEnum.ORGANIZATION_IT_ADMIN) {
    // Don't render tab if organizationId is missing (route guard will handle logout)
    if (!organizationId) {
      return null;
    }
    return (
      <NavLink
        to={`/admin/organizations/${organizationId}/sso-configuration`}
        data-test-id="usersLink"
      >
        {organizationName} SSO Configuration
      </NavLink>
    );
  }

  return (
    <>
      <NavLink end to="/admin/dashboard" data-test-id="dashboardLink">
        Dashboard
      </NavLink>

      <NavLink to="/admin/residents" data-test-id="residentsLink">
        Residents
      </NavLink>

      {displayReportingTab && (
        <NavLink to="/admin/reporting" data-test-id="reportingLink">
          Reporting
        </NavLink>
      )}
    </>
  );
};
